import CustomCard from '../../../../src/components/card/CustomCard'
import CustomCardHeader from '../../../../src/components/card/CustomCardHeader'
import CardBody from '../../../../src/components/card/CardBody'
import BundleTimerUi from '../BundleTimerUi'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import FocusItem from './FocusItem'
import {
  createFocusItem,
  fetchFocusItemList,
  updateFocusItem,
  deleteFocusItem,
  resetFocusItem,
  setActiveTab,
  setIntialPage,
  tryFetchFocusItem,
  resetSearch
} from '../../../redux/slices/focusItemsSlice'
import { isObjectEmpty, trimObject } from '../../../helpers/objectHelper'
import CustomButton, { SemiTransparentButton } from '../../../components/CustomButton'
import CustomTable, {
  TableHeader,
  TableRow,
} from '../../../components/table/CustomTable'
import ConfirmModal from '../../../components/ConfirmModal'
import FocusItemsFormModal from './FocusItemsFormModal'
import { cloneDeep } from 'lodash'
import FocusItemsChooserModal from './FocusItemsChooserModal'
import FocusItemsPreviewModal from './FocusItemsPreviewModal'
import CustomTableItemLoader from '../../../components/CustomTableItemLoader'
import { ACTIVE, FOCUS_ITEMS_TABS, INACTIVE } from '../enums'
import { resetAllSearch, } from "../../../redux/slices/searchSlice";
import FocusItemTab from './FocusItemTab'
import useDidMount from 'hooks/useDidMount'
import { useLocation, useNavigate } from 'react-router'
import FocusItemPaginator from './FocusItemPaginator'

function FocusItemsTable() {
  const {
    loading,
    error,
    processing,
    focusItemList,
    focusItemListCount,
    newFocusItem,
    updateSuccess,
    init,
    tab,
    searchResult
  } = useSelector((state) => state.focusItem)

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isTimerPage, setIsTimerPage] = useState(false)

  const [showModal, setShowModal] = useState(undefined)
  const [showPreviewModal, setShowPreviewModal] = useState(undefined)

  const [focusItemChooserModal, setFocusItemChooserModal] = useState(false)

  const [deleteModal, setDeleteModal] = useState(undefined)
  const [searchId, setSearchId] = useState('')
  const isSearch = !!searchId

  // const [focusItemPlaceholder, setFocusItemPlaceholder] = useState('')

  const [focusItems, setFocusItems] = useState(focusItemList)

  // const [selectedTypeOptions, setSelectedTypeOptions] = useState([])

  // const [selectedDisplayOptions, setSelectedDisplayOptions] = useState([])
  // const [filteredDisplayOptions, setFilteredDisplayOptions] =
  //   useState(FOCUS_DISPLAY_TYPE)
  // const [filteredTypeOptions, setFilteredTypeOptions] =
  //   useState(FOCUS_TYPE_OPTIONS)

  const location = useLocation()

  const setUrl = (url) => {
    window.history.replaceState({}, '', url)
  }

  useEffect(() => {
    const urlParam = new URLSearchParams(location.search)
    const state = urlParam.get('state')
    const page = urlParam.get('page')
    const id = urlParam.get('id')
    const url = new URL(window.location);

    if (id) {
      setSearchId(id)
      fetchFocusItem(id)
    }

    if ([ACTIVE, INACTIVE].includes(state)) {
      dispatch(setActiveTab(FOCUS_ITEMS_TABS.find((x) => x.value === state)))
    } else {
      url.searchParams.set('state', ACTIVE)
      setUrl(url)
    }

    if (parseInt(page)) {
      dispatch(setIntialPage(parseInt(page)))
    } else {
      url.searchParams.set('page', "1")
      setUrl(url)
    }
    fetchFocusItemListAction()
    return () => {
      dispatch(resetFocusItem())
      dispatch(resetAllSearch())
    }
  }, [])

  useDidMount(() => {
    fetchFocusItemListAction()
  }, [tab])

  const fetchFocusItem = (id) => {
    dispatch(tryFetchFocusItem(id))
  }

  const clearSearch = () => {
    navigate('/focus-items?page=1&state=ACTIVE', {replace: true})
    setSearchId('')
    dispatch(resetSearch())
  }

  useEffect(() => {
    if (!isObjectEmpty(newFocusItem) && !processing) {
      if (tab === "ACTIVE") {
        const url = new URL(window.location);
        url.searchParams.set('state', INACTIVE)
        url.searchParams.set('page', "1")
        window.history.replaceState({}, '', url.toString())
      }
      dispatch(setActiveTab(FOCUS_ITEMS_TABS[1]))
      resetForm()
    }
  }, [newFocusItem, processing])

  useEffect(() => {
    if (updateSuccess) {
      resetForm()
    }
  }, [updateSuccess])

  useEffect(() => {
    if (!processing) {
      setDeleteModal(undefined)
    }
  }, [processing])

  const resetForm = () => {
    setShowModal(undefined)
  }

  useEffect(() => {
    if (focusItemList.length !== focusItemListCount && init && !processing) {
      fetchFocusItemListAction()
    }
  }, [focusItemList])

  const fetchFocusItemListAction = () => {
    dispatch(fetchFocusItemList())
  }

  // const initFilterState = () => {
  // setFocusItemPlaceholder('')
  // setSelectedDisplayOptions([])
  // setSelectedTypeOptions([])
  // }


  const onFocusItemFormSubmit = useCallback((data, isEdit) => {
    if (showModal?.edit || isEdit) {
      dispatch(updateFocusItem({ focusItemPayload: trimObject(data) }))
      // initFilterState()
    } else {
      dispatch(createFocusItem({ focusItemPayload: trimObject(data) }))
      // initFilterState()
    }
  }, [showModal?.edit])

  const deleteFocusItemAction = () => {
    dispatch(deleteFocusItem({ focusItemId: deleteModal.id }))
    // initFilterState()
  }

  // const handleTypeSelect = (selectedOption) => {
  //   if (selectedOption) {
  //     setSelectedTypeOptions([...selectedTypeOptions, selectedOption.value])
  //   }
  // }
  //
  // const handleDisplaySelect = (selectedOption) => {
  //   if (selectedOption)
  //     setSelectedDisplayOptions([
  //       ...selectedDisplayOptions,
  //       selectedOption.value,
  //     ])
  // }
  //
  // useEffect(() => {
  //   setFilteredDisplayOptions(
  //     FOCUS_DISPLAY_TYPE.filter(
  //       (displayOption) =>
  //         !selectedDisplayOptions.includes(displayOption.value),
  //     ),
  //   )
  // }, [focusItems, selectedDisplayOptions])
  //
  // useEffect(() => {
  //   setFilteredTypeOptions(
  //     FOCUS_TYPE_OPTIONS.filter(
  //       (typeOption) => !selectedTypeOptions.includes(typeOption.value),
  //     ),
  //   )
  // }, [selectedTypeOptions])

  // const filteredData = () => {
  //   let filteredList = focusItemList.filter(
  //     (item) =>
  //       (!selectedTypeOptions.length ||
  //         selectedTypeOptions.includes(item.type)) &&
  //       (!selectedDisplayOptions.length ||
  //         selectedDisplayOptions.includes(item.display_type)) &&
  //       (focusItemPlaceholder
  //         ? item.title
  //           .toLowerCase()
  //           .includes(focusItemPlaceholder.toLowerCase())
  //         : true),
  //   )
  //   setFocusItems(filteredList)
  // }

  // useEffect(() => {
  //   if (init && !processing) dispatch(fetchFocusItemList(page))
  // }, [selectedDisplayOptions, selectedTypeOptions, focusItemPlaceholder])

  useEffect(() => {
    setFocusItems(focusItemList)
  }, [focusItemList])

  // const FocusItemsDisplayChip = () => {
  //   return selectedDisplayOptions.map((display, index) => (
  //     <Chip
  //       key={index}
  //       label={display}
  //       onClick={() => {
  //         setSelectedDisplayOptions(
  //           selectedDisplayOptions.filter(
  //             (itemDisplay) => itemDisplay !== display,
  //           ),
  //         )
  //       }}
  //     />
  //   ))
  // }
  //
  // const FocusItemsTypeChip = () => {
  //   return selectedTypeOptions.map((type, index) => (
  //     <Chip
  //       key={index}
  //       label={type}
  //       onClick={() => {
  //         setSelectedTypeOptions(
  //           selectedTypeOptions.filter((itemType) => itemType !== type),
  //         )
  //       }}
  //     />
  //   ))
  // }

  const onPageClick = (page) => {
    if (init) {
      dispatch(setIntialPage(page))

      const url = new URL(window.location);
      url.searchParams.set('page', page)
      setUrl(url)
      fetchFocusItemListAction()

    }
  }

  const openDuplicateModal = useCallback((item) => {
    setShowModal({
      ...cloneDeep({
        ...item,
        title: `${item.title} (Copy)`,
        items: item.items.map((d) => ({
          ...d,
          default: d.value,
        })),
      }),
      id: undefined,
    })
  }, [])

  return (
    <>
      <CustomCard>
        <CustomCardHeader color="blue" contentPosition="none">
          <div className="flex items-center justify-between w-full">
            <h2 className="text-2xl text-white">Focus Item</h2>
            <div className="space-x-2">
              <SemiTransparentButton
                onClick={() => setIsTimerPage(!isTimerPage)}
              >
                {isTimerPage ? 'List' : 'Timers'}
              </SemiTransparentButton>

              <SemiTransparentButton
                onClick={() => setFocusItemChooserModal(true)}
              >
                + Add New
              </SemiTransparentButton>
            </div>
          </div>
        </CustomCardHeader>
        {isTimerPage ? (
          <BundleTimerUi />
        ) : (
          <CardBody>
            {/* {!loading && !error.length && (
              <div className="flex justify-between gap-2">
                <div className="w-60">
                  <LabeledSelect
                    options={filteredDisplayOptions}
                    onChange={handleDisplaySelect}
                    placeholder="Select display"
                  />

                  <div className="flex flex-wrap">
                    {selectedDisplayOptions.length !== 0 && (
                      <FocusItemsDisplayChip />
                    )}
                  </div>
                </div>
                <div className="w-60">
                  <LabeledSelect
                    options={filteredTypeOptions}
                    onChange={handleTypeSelect}
                    placeholder="Select Type"
                  />

                  <div className="flex flex-wrap">
                    {selectedTypeOptions.length !== 0 && <FocusItemsTypeChip />}
                  </div>
                </div>

                <div className="border h-[38px] border-gray-300 rounded">
                  <NavbarInput
                    value={focusItemPlaceholder}
                    placeholder="Search focus item..."
                    onChange={(e) => {
                      setFocusItemPlaceholder(e.target.value)
                    }}
                  />
                </div>
              </div>
            )} */}
            <div className="overflow-x-auto">
              {!isSearch && <FocusItemTab />}
              <CustomTable>
                <thead>
                  <TableRow>
                    <TableHeader>Title</TableHeader>
                    <TableHeader>Type</TableHeader>
                    <TableHeader>Display</TableHeader>
                    <TableHeader />
                  </TableRow>
                </thead>
                {loading || error.length > 0 || focusItems.length === 0 ? (
                  <CustomTableItemLoader
                    count={10}
                    colSpan={4}
                    loading={loading}
                    error={error}
                    isEmpty={focusItems.length === 0}
                    retry={fetchFocusItemListAction}
                    loaderItemHeight="h-[66px]"
                  />
                ) : (
                  <tbody>
                    <>
                      {
                        isSearch ?
                          <FocusItem
                            item={searchResult.data}
                            onFocusItemEditClicked={() =>
                              setShowModal({
                                ...cloneDeep({
                                  ...searchResult.data,
                                  items: searchResult.data.items.map((d) => ({
                                    ...d,
                                    default: d.value,
                                  })),
                                }),
                                edit: true,
                              })
                            }
                            onDelete={setDeleteModal}
                            previewModal={showPreviewModal}
                            setPreviewModal={setShowPreviewModal}
                            onDuplicateFocusItem={openDuplicateModal}
                          />
                          : focusItems.map((i) => (
                            <FocusItem
                              key={i.id}
                              item={i}
                              onFocusItemEditClicked={() =>
                                setShowModal({
                                  ...cloneDeep({
                                    ...i,
                                    items: i.items.map((d) => ({
                                      ...d,
                                      default: d.value,
                                    })),
                                  }),
                                  edit: true,
                                })
                              }
                              isActive={tab === ACTIVE}
                              onDelete={setDeleteModal}
                              previewModal={showPreviewModal}
                              setPreviewModal={setShowPreviewModal}
                              onDuplicateFocusItem={openDuplicateModal}
                            />
                          ))}
                    </>
                  </tbody>
                )}
              </CustomTable>
            </div>
            {isSearch
              ? <div className="flex justify-end">
                <CustomButton onClick={() => clearSearch()}>Clear</CustomButton>
              </div>
              : <FocusItemPaginator
                // pageCount={totalPages}
                onPageClicked={onPageClick}
                // initialPage={page - 1}
                // forcePage={page - 1}
              />
            }
          </CardBody>
        )}
      </CustomCard>

      <FocusItemsChooserModal
        showModal={focusItemChooserModal}
        setShowModal={setFocusItemChooserModal}
        setFocusedType={setShowModal}
      />

      {showPreviewModal && (
        <FocusItemsPreviewModal
          setShowModal={setShowPreviewModal}
          showModal={showPreviewModal}
          loading={processing}
          onUpdateFocusItem={onFocusItemFormSubmit}
        />
      )}

      <FocusItemsFormModal
        showModal={showModal}
        setShowModal={() => setShowModal(undefined)}
        loading={processing}
        onSubmit={onFocusItemFormSubmit}
      />

      {/*confirmation dialog modal*/}
      <ConfirmModal
        title="Remove Focus Item"
        children="Are you sure you want to remove this item?"
        showModal={deleteModal}
        setShowModal={() => setDeleteModal(undefined)}
        disabled={processing}
        onConfirm={deleteFocusItemAction}
      />
    </>
  )
}

export default FocusItemsTable
